import { SetupInstance } from '../app/msal-account-helpers';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

/**
 * Thin, MSAL-aligned helper that:
 * - Relies solely on MSAL's internal token cache/refresh.
 * - Uses acquireTokenSilent for normal operation.
 * - On InteractionRequiredAuthError, it logs and rethrows so that callers or
 *   higher-level auth gates decide when and how to trigger interactive flows.
 */
export class AccessTokenHelper {

    // Global flag to avoid multiple concurrent redirects
    static isRedirecting = false;

    /**
     * Acquire an access token for the given request.
     *
     * @param {PublicClientApplication} instance MSAL instance
     * @param {InteractionStatus} inProgress Current MSAL interaction status
     * @param {object} accessTokenRequest Request with scopes and optional account/authority
     */
    getAccessToken = async (instance, inProgress, accessTokenRequest) => {
        const msalInstance = SetupInstance(instance);

        const request = {
            ...accessTokenRequest,
            // Fallback to active account if none explicitly supplied
            account: accessTokenRequest.account || msalInstance.getActiveAccount()
        };

        try {
            return await msalInstance.acquireTokenSilent(request);
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                console.warn('Silent token acquisition requires interaction (no auto-redirect):', error);
            }
            throw error;
        }
    };
}